<template>
  <div class="d-flex flex-column py-5">
    <div class="d-block text-h6 black--text font-weight-bold mt-4">Lokasi Tokomu</div>
    
    <v-card flat outlined :loading="loading" class="mt-3">
      <v-card-text>
        <v-form ref="formAddAddress" role="form">
          <v-row class="align-center" v-if="!loading">
            <v-col cols="12" sm="3" class="py-xs-0">
              <div class="d-flex flex-column text-subtitle-2 font-weight-bold black--text">Provinsi</div>
            </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete v-model="province" :rules="rules.province" :items="provinces" item-text="province" item-value="province_id" return-object single-line outlined class="rounded-lg text-body-1" height="45" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeProvince(province.province_id)"></v-autocomplete>
            </v-col>
          </v-row>

          <v-row class="align-center" v-if="province">
            <v-col cols="12" sm="3" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text">Kota/Kabupaten</div></v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete v-model="city" :rules="rules.city" :items="cities" :item-text="item => item.type + ' ' + item.city_name" item-value="city_id" return-object single-line outlined class="rounded-lg text-body-1" height="45" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeCity(city.city_id)">
                <template v-slot:item = {item}>
                  {{ item.type }} {{ item.city_name }}
                </template>
                <template v-slot:selection = {item}>
                  {{ item.type }} {{ item.city_name }}
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row class="align-center" v-if="city">
            <v-col cols="12" sm="3" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text">Kecamatan</div></v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete v-model="subdistrict" :rules="rules.subdistrict" :items="subdistricts" item-text="subdistrict_name" item-value="subdistrict_id" return-object single-line outlined class="rounded-lg text-body-1" height="45" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeSubdistrict(subdistrict.postal_code)"></v-autocomplete>
            </v-col>
          </v-row>

          <v-row class="align-center" v-if="city">
            <v-col cols="12" sm="3" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text">Kode Pos</div></v-col>
            <v-col cols="12" sm="7">
              <v-text-field v-model="zipcode" single-line outlined class="rounded-lg text-body-1" height="45" dense placeholder="Kode Pos" hide-details="auto"></v-text-field>
            </v-col>
          </v-row>

          <v-row class="align-start" v-if="city">
            <v-col cols="12" sm="3" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text">Alamat Lengkap</div></v-col>
            <v-col cols="12" sm="7">
              <v-textarea v-model="address" :rules="rules.address" single-line outlined class="rounded-lg text-body-1" placeholder="Isi nama jalan, nomor rumah, nama gedung, dsb" hide-details="auto" no-resize></v-textarea>
            </v-col>
          </v-row>

          <v-row class="align-start">
            <v-col cols="12" sm="3" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text">GPS Longitude</div></v-col>
            <v-col cols="12" sm="7">
              <v-text-field v-model="longitude" single-line outlined class="rounded-lg text-body-1" height="45" dense placeholder="longitude" hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          
          <v-row class="align-start">
            <v-col cols="12" sm="3" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text">GPS Latitude</div></v-col>
            <v-col cols="12" sm="7">
              <v-text-field v-model="latitude" single-line outlined class="rounded-lg text-body-1" height="45" dense placeholder="latitude" hide-details="auto"></v-text-field>
              <v-btn
                color="primary"
                outlined
                class="mt-4 px-5 text-capitalize white--text btn-block-xs"
                @click="saveAddress()"
              >
                Pilih Otomatis dari Peta
              </v-btn>
            </v-col>
          </v-row>

          <v-row class="align-start">
            <v-col cols="12" sm="3" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text"></div></v-col>
            <v-col cols="12" sm="7">
              
            </v-col>
          </v-row>

          <hr class="mt-5">
          <v-row v-if="!loading">
            <v-col cols="12" sm="10" class="text-right">
              <v-btn
                color="green"
                :loading="loadingProcess"
                class="my-2 px-5 text-capitalize white--text btn-block-xs"
                @click="saveAddress()"
              >
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'penghasilan-saya',
  data() {
    return {
      loadingProcess: false,
      loading: false,
      address: '',
      province: null,
			city: null,
			subdistrict: null,
			zipcode: '',
			receipt_name: '',
			mobilephone: '',
			longitude: '',
      latitude: '',
      rules:{
        province: [
          v => !!v || 'Provinsi tidak boleh kosong',
        ],
        city: [
          v => !!v || 'Kota tidak boleh kosong',
        ],
        subdistrict: [
          v => !!v || 'Kecamatan tidak boleh kosong',
        ],
        address: [
          v => !!v || 'Detail alamat tidak boleh kosong',
				],
      }
    }
  },

  computed: {
    ...mapState('options', ['provinces', 'cities', 'subdistricts']),
    ...mapState('storeSeller', ['detailStore', 'response', 'responseError'])
  },

  methods: {
    ...mapActions('options', ['getProvince', 'getCity', 'getSubdistrict']),
    ...mapActions('storeSeller', ['getStoreDetail', 'updateStore']),
    ...mapMutations(['makeAlert']),

    async saveAddress() {
			if(this.$refs.formAddAddress.validate()) {
        this.loadingProcess = await true
				let params = {
          name: this.detailStore.store_name,
          slug: this.detailStore.store_slug,
          courier: JSON.parse(this.detailStore.store_courier),
          address: this.address,
					province_id: this.subdistrict.province_id,
					province_name:this.subdistrict.province,
					city_id: this.subdistrict.city_id,
					city_name: this.subdistrict.city_name,
					subdistrict_id: this.subdistrict.subdistrict_id,
					subdistrict_name: this.subdistrict.subdistrict_name,
					zipcode: this.zipcode,
					longitude: this.longitude,
					latitude: this.latitude
        }
        
        this.updateStore(params)
          .then(async() => {
            await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
            await this.getStoreDetail()
            if (this.detailStore) {
              this.loading = await false
              if (this.provinces) await this.getCity({ province_id: this.detailStore.store_province_id	})
              if (this.cities) await this.getSubdistrict({ city_id: this.detailStore.store_city_id	})
              this.province = this.provinces.find( (el) => el.province_id === this.detailStore.store_province_id)
              this.city = this.cities.find( (el) => el.city_id === this.detailStore.store_city_id)
              this.subdistrict = this.subdistricts.find( (el) => el.subdistrict_id === this.detailStore.store_subdistrict_id)
              this.zipcode = this.detailStore.store_zipcode
              this.address = this.detailStore.store_address
              this.longitude = this.detailStore.store_longitude
              this.latitude = this.detailStore.store_latitude
            }
            this.loading = false
            this.loadingProcess = false
          })
          .catch(() => {
            this.loadingProcess = false
          })
			} else {
        this.loadingProcess = false
      }
    },
    
    changeProvince(id) {
			this.city = null
			this.subdistrict = null
			this.getCity({
				province_id: id
			})
		},
		changeCity(id) {
			this.subdistrict = null
			this.zipcode = null
			this.getSubdistrict({
				city_id: id
			})
		},
		changeSubdistrict(code) {
			this.zipcode = code
		},
  },

  async mounted() {
    this.loading = await true
    // await this.getStoreDetail()
    await this.getProvince()
    if (this.detailStore) {
      if (this.provinces) await this.getCity({ province_id: this.detailStore.store_province_id	})
      if (this.cities) await this.getSubdistrict({ city_id: this.detailStore.store_city_id	})
      this.province = this.provinces.find( (el) => el.province_id === this.detailStore.store_province_id)
      this.city = this.cities.find( (el) => el.city_id === this.detailStore.store_city_id)
      this.subdistrict = this.subdistricts.find( (el) => el.subdistrict_id === this.detailStore.store_subdistrict_id)
      this.zipcode = this.detailStore.store_zipcode
      this.address = this.detailStore.store_address
      this.longitude = this.detailStore.store_longitude
      this.latitude = this.detailStore.store_latitude
    }
    this.loading = false
  },

  created() {
    this.$store.dispatch('setPageTitle', `Ubah Alamat`);
  }
}
</script>